import { useConciergeResume } from '@/hooks/useConciergeResume';

/**
 * Invisible component that auto-submits concierge drafts after signup.
 * Mount once near the app root, inside AuthProvider + QueryClientProvider.
 */
export function ConciergeResumeHandler() {
  useConciergeResume();
  return null;
}
